module.exports = __webpack_public_path__ + "images/花筑村全景_08-4.jpg?v=364103a4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_08-4.jpg
 ** module id = 103
 ** module chunks = 1 2
 **/